// extracted by mini-css-extract-plugin
export var aiStarIcon = "_je-2";
export var container = "_je-4";
export var dismissButton = "_je-3";
export var hasPaddingBottom = "_je-6";
export var last = "_je-e";
export var scrollbarThumb = "_je-c";
export var scrollbarTrack = "_je-b";
export var selected = "_je-9";
export var spin = "_je-1";
export var spinning = "_je-0";
export var suggestionItem = "_je-d";
export var suggestionsPanel = "_je-5";
export var tonePill = "_je-8";
export var tonesContainer = "_je-7";
export var unselected = "_je-a";